import { configContentHub, configTeaser } from "@pub/config";
import placeholders from "@pub/placeholders";
import { Card, LatestArticle } from "@sphtech/dmg-design-system";
import { ContentHubData } from "@src/app/types/ServerCustomContext";
import { getVariantByIndex } from "@src/app/utils/VariantByIndex";
import cx from "classnames";

import styles from "../contenthub.module.css";

type Props = {
  data: Omit<ContentHubData, "metaData">;
  firstItemAnchorBlock?: boolean;
  from?: number;
  limit?: number;
};

const mapCropByIndex = configContentHub.contenthubBlockF?.cropByIndex
  ? new Map(configContentHub.contenthubBlockF.cropByIndex)
  : null;

export default function ContentHubBlockF({
  data,
  firstItemAnchorBlock = false,
  from = 0,
  limit = 4,
}: Props) {
  const topOrContentListStories = data.contentHubList
    ? data.contentHubList.teasers
    : data.topStories && data.topStories.slice(from, limit);

  if (!topOrContentListStories) {
    return null;
  }

  const contentHubLayout = configContentHub.cardLayout?.contentBlockF;

  return (
    <section className={styles.contentHubBlockF}>
      <div
        className={cx(
          styles.bodyContainer,
          styles.secondaryContentContainer,
          styles.gutterHorizontal,
        )}
      >
        {data.contentHubList?.title && (
          <a
            href={data.contentHubList.titleUrl}
            className={styles.titleContainer}
          >
            <div className={styles.title}>{data.contentHubList.title}</div>
            <div className={styles.description}>
              {data.contentHubList.description}
            </div>
          </a>
        )}
        <div className={styles.primaryContentBlockContainer}>
          <div className={styles.primaryContentBlockLayout}>
            {topOrContentListStories.map((teaser, index: number) => (
              <div
                key={index}
                className={cx(
                  index === 0 &&
                    configContentHub.contenthubBlockF
                      ?.anchorBlockOnAllScreens &&
                    styles.fullWidth,
                  firstItemAnchorBlock
                    ? styles.primaryContentBlockItem
                    : styles.item,
                )}
              >
                {contentHubLayout ? (
                  <Card
                    key={index}
                    {...teaser}
                    variant={contentHubLayout.defaultVariant}
                    mobileUpVariant={
                      contentHubLayout.mobileUp.variantsByIndex
                        ? getVariantByIndex(contentHubLayout.mobileUp, index)
                        : contentHubLayout.mobileUp.defaultVariant
                    }
                    placeholders={placeholders}
                    displayPublishDate={configTeaser.publishDate}
                  />
                ) : (
                  <LatestArticle
                    key={index}
                    {...teaser}
                    mode={
                      configContentHub.contenthubBlockF?.mode ||
                      (firstItemAnchorBlock && index === 0)
                        ? mapCropByIndex?.get(index) || "landscape"
                        : "portrait"
                    }
                    mobileMode={configContentHub.contenthubBlockF?.mobileMode}
                    placeholders={placeholders}
                    displayPublishDate={configTeaser.publishDate}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
